export default __webpack_public_path__ + "static/poster-53d80f620a4cd662e0c72442cd425f96.png";